module.exports = __webpack_public_path__ + "static/img/hat.3067f2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/hat.png
// module id = e19M
// module chunks = 0